<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <svg
    :width="width"
    :height="height"
    viewBox="0 0 10 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :class="styles"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.3773 3.598C8.81063 3.48467 8.0453 3.4 7.56397 3.4C6.26064 3.4 6.17598 3.96667 6.17598 4.87333V6.48734H9.43397L9.14997 9.83067H6.17598V20H2.09666V9.83067H0L0 6.48734H2.09666V4.41933C2.09666 1.58667 3.42799 0 6.77065 0C7.93198 0 8.78197 0.170001 9.88663 0.396667L9.3773 3.598Z"
    />
  </svg>
</template>

<script lang="ts" setup>
import { defineProps, computed, toRefs } from "vue";
export interface IconLinkProps {
  color?: string;
  width?: string;
  height?: string;
  classes?: string;
}

const props = withDefaults(defineProps<IconLinkProps>(), {
  color: "white",
  width: "100%",
  height: "100%",
});

const { color, width, height, classes } = toRefs(props);
const styles = computed(() => {
  return `${color.value}  group-hover:fill-orange transition-colors ${classes?.value}`;
});
</script>
